import React, {
  useState,
  useContext,
}                        from 'react';
import styled, {
  keyframes,
}                        from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import useBasicI18N      from '../../hooks/useBasicI18N';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 36px;
  height: 36px;
  border: 3px solid #e4e9f0;
  border-top-color: #1a1a2e;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  margin: 0 auto 1rem;
`;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #1a1a2e;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 0.85rem 2rem;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
  &:hover  { background: #16213e; transform: translateY(-1px); }
  &:active { transform: translateY(0); }
`;

const UnsubscribePortal = () => {
  const getTranslation = useBasicI18N();
  const [ done_message, setDoneMessage ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const compact = useMediaQuery({ maxWidth: 480 });

  const { token } = useContext(window.DealerInfo);

  const unsubscribe = () => {
    setLoading(true);
    fetch('/gdpr/unsubscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    }).then(() => {
      setDoneMessage(true);
      setLoading(false);
    });
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '1.5rem',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e9f0 100%)',
      boxSizing: 'border-box',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
        padding: compact ? '2rem 1.5rem' : '3rem',
        maxWidth: '480px',
        textAlign: 'center',
      }}>
        <h1 style={{
          fontSize: compact ? '1.5rem' : '1.75rem',
          color: '#1a1a2e',
          margin: '0 0 0.5rem 0',
        }}>
          {getTranslation('unsubscribe')}
        </h1>
        <p style={{
          fontSize: '1rem',
          lineHeight: 1.6,
          color: '#555',
          marginBottom: '2rem',
        }}>
          {getTranslation('unsubscribe_text')}
        </p>
        {loading && <Spinner />}
        {!loading && done_message && (
          <>
            <div style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: '#e8f5e9',
              color: '#2e7d32',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem',
              margin: '0 auto 1rem',
            }}>
              &#10003;
            </div>
            <p style={{
              fontSize: '1rem',
              lineHeight: 1.6,
              color: '#2e7d32',
              margin: 0,
            }}>
              {getTranslation('unsubscribe_done_message')}
            </p>
          </>
        )}

        {!loading && !done_message && (
          <Button onClick={unsubscribe}>
            {getTranslation('unsubscribe_button')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePortal;
